import { __rest, __assign } from 'tslib';
import * as React from 'react';

var Triangle = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (React.createElement("svg", __assign({ height: 9, viewBox: "0 0 9 9", width: 9, xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("title", null, title || 'Triangle'),
        React.createElement("path", { d: "M7.882 4.5L.5 8.191V.809L7.882 4.5z", fill: "#2C6BAA", fillRule: "evenodd", stroke: "#2C6BAA" })));
};

export { Triangle as default };
//# sourceMappingURL=Triangle.esm.js.map
